import "./Teachers.module.css";
import Header from "@/reusable_sections/Header";
import MeetTheTeachers from "./sections/MeetTheTeachers";
import Footer from "@/reusable_sections/Footer";
export default function TeachersPage() {
  return <div>
      <Header />
      <MeetTheTeachers />
      <Footer />
    </div>;
}